/**
 * indexTabAvailability.ts
 * Item 5.1 — pure enablement rule for the Scenario Planner's ("Index tests")
 * tab (I20). Renumbered from Phase 3 to Phase 2 by Item 9.1 (R1 — owner
 * revision 2026-07-23: Machine → Index → Employee planning).
 *
 * Extracted out of ScenarioPhaseStepper.tsx so it's unit-testable without
 * mounting the wizard: the tab is enabled iff the active source has at least
 * one active IndexAllocation row (fetched via services/scheduleIndex.ts),
 * independent of the Phase-1 soft gate (unplaced tasks / hard conflicts).
 */

/** Tooltip shown on the greyed-out Index tab when it has no index tests. */
export const INDEX_TAB_DISABLED_TOOLTIP = 'This quote has no index tests';

/**
 * True when the Phase-3 tab should be enabled for the given allocation count.
 * `null` (not yet loaded) is treated as disabled — matches the initial state
 * before the first `listIndexAllocations` response lands.
 */
export function isIndexTabEnabled(indexAllocationCount: number | null): boolean {
  return (indexAllocationCount ?? 0) > 0;
}
